
export default {
  name: 'RichText',

  props: {
    slice: {
      type: Object,
      required: true,
    },
  },
}
